/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts } from '../../../theme';
import { IAttrStyled } from '../../../types/globalTypes';

export interface IStyledDragAndDrop extends IAttrStyled {
    required?: boolean;
    order: number;
    icon?: string;
}

const SettingContainerStyled = styled.div.attrs({
    className: 'table-setting-wrapper',
})`
    width: 600px;
    box-sizing: border-box;
    margin: 24px 0;
`;

const HeaderStyled = styled.div.attrs({
    className: 'table-setting-wrapper__setting-header',
})`
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 24px;
    padding: 0 24px;
`;

const TitleStyled = styled.div.attrs({
    'className': 'table-setting-wrapper__setting-header-title',
    'data-table-setting-header-title': 'tableSettingHeaderTitle',
})`
    ${fonts.textHeader3};
`;

const SubTitleStyled = styled.span.attrs({
    'data-table-setting-header-sub-title': 'tableSettingHeaderSubTitle',
})``;

const BodyStyled = styled.div.attrs({
    className: 'table-setting-wrapper__setting-body',
})`
    width: 100%;
    box-sizing: border-box;
    padding: 24px;
    background-color: ${colors.tableSettingBgColorModal};
`;

const DragAndDropContainerStyled = styled.div.attrs({
    'className': 'table-setting-wrapper__setting-body-drag-and-drop',
    'data-setting-body-drag-and-drop': 'tableSettingBodyDragAndDrop',
})`
    height: 280px;
    width: 100%;
    overflow-y: scroll;
    background-color: ${colors.tableSettingDragAndDropBgColorModal};
`;

const DragAndDropItemStyled = styled.div.attrs(({ className }: { className: string }) => ({
    className: `table-setting-wrapper__setting-body-drag-and-drop-item ${className || ''}`,
}))<IStyledDragAndDrop>`
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    width: inherit;
    height: 40px;
    padding-left: 14px;
    box-sizing: border-box;

    &.table-setting-wrapper__setting-body-drag-and-drop-item_no-drop {
        border-bottom: 1px solid ${colors.tableSettingDragAndDropNoDropBorderColor};
    }

    ${
    (props) => props.required
        ? `
            & .text-block {
                flex: 1 1 auto;
                padding-left: 32px;
            }
            & .text-block:after {
                margin-left: 5px;
                content: "*";
                font-size: 17px;
                color: ${colors.tableSettingDragAndDropRequiredColor};
            }
        ` : ''
}
`;

const FootnoteStyled = styled.div.attrs({
    className: 'table-setting-wrapper__setting-footnote',
})`
    width: 100%;
    box-sizing: border-box;
    padding: 16px 24px 0;
    color: ${colors.tableSettingTextColorSecondary};

    &::before {
        content: "*";
        margin-right: 5px;
        font-size: 17px;
        color: ${colors.tableSettingTextColorDanger};
    }
`;

const FooterContainerStyled = styled.div.attrs({
    className: 'table-setting-wrapper__setting-footer',
})`
    display: flex;
    width: 100%;
    box-sizing: border-box;
    padding: 24px 24px 0;
`;

const FooterCloseStyled = styled.div.attrs({
    className: 'table-setting-wrapper__setting-footer-close',
})`
    display: flex;
    align-items: center;
    margin-left: 16px;
    cursor: pointer;
`;

export {
    BodyStyled,
    DragAndDropContainerStyled,
    DragAndDropItemStyled,
    FooterCloseStyled,
    FooterContainerStyled,
    FootnoteStyled,
    HeaderStyled,
    SettingContainerStyled,
    SubTitleStyled,
    TitleStyled,
};
